/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useSelector } from 'react-redux';
import Spinner from './Spinner';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { RootState } from '@rb-serve-app/core';

// Define props types
interface PdfViewerProps {
  fromDate: string;
  toDate: string;
  file: string | File | null;
  onClose: () => void;
  onDownload: (file: string) => void;
  pageCount: any;
  progress:any;
  userFriendlyMsg:string|null;
}

const PdfViewer: React.FC<PdfViewerProps> = ({
  file,
  fromDate = '',
  toDate = '',
  onClose,
  onDownload,
  pageCount,
  progress,
  userFriendlyMsg
}) => {
  const [zoom, setZoom] = useState(1.0); // Initial zoom level
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  

  const { entries, assets } = contentfulData;
  const { rb_statements } = entries;

  // Handler for zooming in
  const handleZoomIn = () => {
    setZoom((prevZoom) => Math.min(prevZoom + 0.1, 3.0)); // Max zoom level is 3.0
  };

  // Handler for zooming out
  const handleZoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 0.1, 0.5)); // Min zoom level is 0.5
  };

  // Calculate zoom percentage
  const zoomPercentage = Math.round(zoom * 100);

  const handleDownload = () => {
    if (file) {
      if (typeof file === 'string') {
        onDownload(file);
      } else if (file instanceof File) {
        const fileURL = URL.createObjectURL(file);
        onDownload(fileURL);
      }
    }
  };
  const [pages, setPages] = useState<React.ReactElement[]>([]);
  useEffect(() => {
    if (pageCount > 0) {
      const pagesArray = [];
      for (let i = 1; i <= pageCount; i++) {
        pagesArray.push(
          <Page
            key={i}
            pageNumber={i}
            scale={zoom}
            renderAnnotationLayer={true}
            renderTextLayer={true}
          />
        );
      }
      setPages(pagesArray);
    }
  }, [pageCount, zoom]);
  console.log(pages, 'pages', pageCount);
  // useEffect(() => {
  //   setProgress(loaderPercentage);
  // }, [loaderPercentage]);

  return (
    <div className="pdf-viewer flex flex-col h-full w-full">
      <div className="flex flex-col-reverse  w-full items-center md:flex-row bg-bg-body">
        <p className="flex-1 font-bold w-full flex flex-col md:flex-row px-8 py-10 text-[22px] text-sm md:text-[22px]">
          <span>
            {rb_statements.statementForPeriodTitle}: {toDate}
          </span>
        </p>
        <div className="flex justify-between flex-row-reverse md:flex-row w-full md:w-auto items-center">
          <div
            onClick={handleDownload}
            className="cursor-pointer"
            title={rb_statements.download ?? 'download'}
          >
            <img
              src={assets.statement_download_web_icon}
              className="w-8 h-8 hidden md:block"
              alt="StatementDownloadWebIcon"
            />
            <span className="block md:hidden p-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6Z"
                  fill="#1F1F1F"
                />
              </svg>
            </span>
          </div>
          <div onClick={onClose} className="close-btn p-3 cursor-pointer">
            <img
              src={assets.popup_close_icon}
              className="w-6 h-6"
              alt="PopupCloseIcon"
            />
          </div>
        </div>
      </div>

      <div
        className=" w-10/12 items-center justify-center overflow-auto p-2 max-w-screen-sm mx-auto border-none md:border-[5px] md:border-solid md:border-greyBorder
      scrollbar min-h-[65vh] mt-[20px]"
      >
        {file ? (
          pageCount > 0 && (
            <Document
              className="items-center"
              file={file}
              onLoadSuccess={({ numPages }) =>
                console.log(`Loaded a document with ${numPages} pages.`)
              }
            >
              {/* <Page pageNumber={1} scale={zoom} /> */}
              {pages}
            </Document>
          )
        ) : (
          <div className="flex justify-center items-center h-[100%] flex-col">
            <Spinner />
            <p>{progress}%</p>
            <p>{userFriendlyMsg}</p>
          </div>
        )}
      </div>
      <div className="hidden md:flex flex-row justify-between p-2 items-center max-w-screen-sm mx-auto">
        <p className="p-5">Zoom</p>
        <button
          onClick={handleZoomOut}
          className="flex justify-center items-center p-0 w-10 h-10 rounded-full mr-2 cursor-pointer bg-transparent hover:bg-[#fafafa] text-lg md:text-xl transition-colors duration-200"
        >
          -
        </button>

        <p className="text-lg text-center flex-1">{zoomPercentage}%</p>
        <button
          onClick={handleZoomIn}
          className="flex justify-center items-center p-0 w-10 h-10 rounded-full mr-2 cursor-pointer bg-transparent hover:bg-[#fafafa] text-lg md:text-xl transition-colors duration-200"
        >
          +
        </button>
      </div>
    </div>
  );
};

export default PdfViewer;
